import { ProcessTemplateDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import {
  ProcessInputFields,
  StepTemplate,
  Template,
  TemplateInputCategory,
} from 'modules/processes/domain/index'

export const useTemplate = (id: string | undefined) => {
  const category = id === 'custom' ? 'default' : id

  const { data, loading } = useQuery(ProcessTemplateDocument, {
    variables: { id: category || '' },
    skip: !id,
  })

  const stepsObject = data?.processes.template?.stepObjects
  const stepsString = data?.processes.template?.steps?.at(0)

  const processInputFieldsObject = data?.processes.template?.processInputFieldObjects
  const processInputFieldsString = data?.processes.template?.processInputFields?.at(0)

  const dataCollectionInputCategoriesObject =
    data?.processes.template?.dataCollectionInputCategoriesObjects
  const dataCollectionInputCategoriesString =
    data?.processes.template?.dataCollectionInputCategories?.at(0)

  const steps: StepTemplate[] = stepsObject
    ? stepsObject
    : // TODO: Remove this once we deprecate the __dangerously_convert_to_string_in_graphql flag
    stepsString
    ? JSON.parse(stepsString)
    : []

  const processInputFields: ProcessInputFields[] = processInputFieldsObject
    ? processInputFieldsObject
    : // TODO: Remove this once we deprecate the __dangerously_convert_to_string_in_graphql flag
    processInputFieldsString
    ? JSON.parse(processInputFieldsString)
    : []

  const dataCollectionInputCategories: TemplateInputCategory[] = dataCollectionInputCategoriesObject
    ? dataCollectionInputCategoriesObject
    : // TODO: Remove this once we deprecate the __dangerously_convert_to_string_in_graphql flag
    dataCollectionInputCategoriesString
    ? JSON.parse(dataCollectionInputCategoriesString)
    : []

  const dataTemplate = data?.processes.template

  const template: Template | undefined = dataTemplate
    ? {
        ...dataTemplate,
        steps: steps,
        processInputFields,
        dataCollectionInputCategories,
      }
    : undefined

  return {
    loading: loading,
    template,
    error: false,
  }
}
